import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_NEW_PROJECTS_FAILURE, FETCH_NEW_PROJECTS_REQUEST, FETCH_NEW_PROJECTS_SUCCESS } from "../actions/newProjectsActions";

  const initialState = {
    newProjectsData: [],
    newProjectsLoading: true,
    newProjectsError: null,
  };
  
  const newProjectsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NEW_PROJECTS_REQUEST:
        return { ...state, newProjectsLoading: true , payload: action.payload};
      case FETCH_NEW_PROJECTS_SUCCESS:
        return { ...state, newProjectsLoading: false, newProjectsData: action.payload };
      case FETCH_NEW_PROJECTS_FAILURE:
        return { ...state, newProjectsLoading: false, newProjectsError: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:  
      return { ...state, newProjectsData: [], newProjectsLoading: false};
      default:
        return state;
    }
  };
  
  export default newProjectsReducer;
  